import { render, staticRenderFns } from "./committeestatistics.vue?vue&type=template&id=867d3f50&scoped=true&"
import script from "./committeestatistics.vue?vue&type=script&lang=js&"
export * from "./committeestatistics.vue?vue&type=script&lang=js&"
import style0 from "./committeestatistics.vue?vue&type=style&index=0&id=867d3f50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867d3f50",
  null
  
)

export default component.exports